export const WIDE_DESKTOP_MIN_WIDTH = 1654
